import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { isUndefined } from 'underscore';

import * as productActions from '../../../core/product/productActions';
import * as supplierActions from '../../../core/supplier/supplierActions';
import Loading from '../../../elements/Loading';

import DOM from './updateProduct';

const { EXCLUDE_FROM_AUTO, EXCLUDE_FROM_LETTER, DEFAULT_SUPPLIER_NAME } = require('../../../core/utils/values').default;

class UpdateProductForm extends Component {
    constructor(props) {
        super(props);
        this.handleSetPageName(props);
        this.view = DOM;
        this.handleUpdateProductSubmit = this.handleUpdateProductSubmit.bind(this);
    }

    componentWillMount() {
        const { actions, productId } = this.props;
        actions.getProductRequest(productId);
        actions.getSuppliersRequest();
        actions.getProductCategoriesRequest();
    }

    componentDidMount() {
        if (!this.props.suppliers || this.props.suppliers?.length === 0) {
            this.props.actions.getSuppliersRequest();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.handleSetPageName(nextProps);
    }

    // Handle set page name
    handleSetPageName(props) {
        const { setPageName, initialValues, productId, isFetching } = props;
        if (!isFetching) {
            if (!isUndefined(initialValues.title)) {
                setPageName(`#${initialValues.id} - ${initialValues.title}`);
            } else if (productId === 0) {
                setPageName('New Product');
            }
        }
    }

    // Handle submit form
    handleUpdateProductSubmit = (values) => {
        const { actions, productId, suppliers } = this.props;

        let requires_prescription = 0;
        if ('requires_prescription' in values) {
            requires_prescription = values.requires_prescription === 0 ||
                                    values.requires_prescription === false ||
                                    values.requires_prescription === '' ? 0 : 1;
        }

        const settings = values.settings || [];
        const exclude_from_auto = settings.includes(EXCLUDE_FROM_AUTO) ? 1 : 0;
        const exclude_from_letter = settings.includes(EXCLUDE_FROM_LETTER) ? 1 : 0;
        // Default supplier set in values
        const defaultSupplier = suppliers.find(item => item.title.toLowerCase() === DEFAULT_SUPPLIER_NAME);

        const formValues = {
            id: productId,
            ...values,
            supplier_id: defaultSupplier?.id,
            requires_prescription,
            exclude_from_auto,
            exclude_from_letter,
        };

        delete formValues.settings;

        actions.updateProductRequest(formValues);
    };

    render() {
        const { isFetching, suppliers } = this.props;
        if (isFetching || !suppliers || suppliers.length === 0) {
            return <Loading />;
        }
        return this.view();
    }
}

UpdateProductForm.propTypes = {
    actions: PropTypes.object.isRequired,
    productId: PropTypes.number.isRequired,
    isFetching: PropTypes.bool,
    suppliers: PropTypes.array,
};

UpdateProductForm.defaultProps = {
    isFetching: false,
    suppliers: [],
};

const UpdateProduct = reduxForm({
    form: 'update-product',
    enableReinitialize: true,
})(UpdateProductForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        initialValues: state.product.product,
        isFetching: state.product.isFetching,
        productCategories: state.product.productCategories,
        suppliers: state.supplier.suppliers.rows,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...productActions,
            ...supplierActions,
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProduct);
